import React from 'react';
import PropTypes from 'prop-types';

import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { ConsumerReviewsModel, ConsumerReviewsPaths } from 'client/data/models/consumer-reviews';
import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';

export function ConsumerRatingUI({ reviewsAggregation = undefined }) {
  const reviewsRating = reviewsAggregation?.reviewsRating;

  if (!reviewsRating) {
    return null;
  }

  return (
    <li className="d-flex justify-content-between py-1 border-top">
      <span className="text-cool-gray-40">Consumer Rating</span>
      <span className="d-flex align-items-center gap-0_5">
        <RatingStars rating={reviewsRating} starClass="text-blue-50" hideForScreenReader />
        <strong className="text-cool-gray-30">{reviewsRating}/5</strong>
      </span>
    </li>
  );
}

ConsumerRatingUI.propTypes = {
  reviewsAggregation: PropTypes.shape({
    reviewsRating: PropTypes.number,
  }),
};

const stateToPropsConfig = {
  reviewsAggregation: bindToPath(
    ({ make, model, year }) =>
      make && model && year ? ConsumerReviewsPaths.buildReviewsAggregationPath({ make, model, year }) : null,
    ConsumerReviewsModel
  ),
};

export const ConsumerRating = connectToModel(ConsumerRatingUI, stateToPropsConfig);
